export const decodeOtherLanguage = function (strToDecode) {
  if (!strToDecode || strToDecode == '') {
    return '';
  }
  const result = decodeURIComponent(escape(window.atob(strToDecode)));
  return result === 'null'?'':result;
};


export const showEmbedFooter = function() {
    const url = new URL(window.location);
    let showEmbedFooter = false;
    if (url) {
      const params = new URLSearchParams(url.search);
      if (params) {
        showEmbedFooter = (params.get("embed") && params.get("embed") === 'true')?true:false;
        console.log('showFooter ', showEmbedFooter);
      }
    }
    return showEmbedFooter;
  };


export const getUrlWord = function (urlPath, hash = null) {
  // [hash removal] remove this after hash migration
  if (hash && hash != '') {
    return hash.replace(/(^#)/g, "");
  }
  let urlArray = urlPath.split('/');
  if (urlArray[1] && urlArray[1] != '' && urlArray[2] && urlArray[2] != '') {
    return `/${urlArray[1]}/${urlArray[2]}`;
  }
  console.log('window', '__CURL_' + window.location.hostname.replace(/\./g, "_"));
  return '__CURL_' + window.location.hostname.replace(/\./g, "_");
};

export const getTippingUserSelections = function () {
  return localStorage.getItem('tippingUserSelections') && JSON.parse(localStorage.getItem('tippingUserSelections'));
}

export const getGlobalCode = (code) => {
  if (code && code != '') {
    return window.atob(code);
  } else {
    return '';
  }
}

export const injectGlobalCode = ($, htmlTag, code) => {
  if (code && code != '' && code.trim().length > 0) {
    var targetHtmlElement = $(htmlTag);
    if (targetHtmlElement) {
      targetHtmlElement.append(code);
    }
  }
}

export const shapesList = {
      1: '',
      2: 'no-border-radius',
      3: 'no-border-radius dyn-skew',
      4: 'dyn-circle',
      5: 'no-border-radius dyn-shield',
    };

export const isFooterIconsPresent = function (footerArray) {
  let iconPresent = false;
  footerArray.forEach(f => {
    if ((['scrollIcon', 'link'].includes(f.footerType)
      && f.location && f.location != '')) {
      iconPresent = true;
    }
  })
  return iconPresent;
}

export const isNotEmpty = function (str) {
  return str && str != null && typeof str === 'string' && str.trim() !== '';
}
